import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Text from './Text';
var StyledLink = styled(Text)(_templateObject(), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primaryHover;
});

function Link(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  return _jsx(StyledLink, Object.assign({
    as: "a"
  }, rest, {
    children: children
  }), void 0);
}

export default Link;